import * as yup from "yup";

export const promoSchema = yup
  .object({
    code: yup
      .string()
      .required("Code is required")
      .matches(/^[A-Z0-9_-]+$/i, "Only letters, numbers, _ and - allowed")
      .default(""),
    discount_percent: yup
      .number()
      .typeError("Discount is required")
      .required("Discount is required")
      .min(1, "Must be between 1 and 100")
      .max(100, "Must be between 1 and 100"),
    // When true the promo applies to every show — submitted as an empty `shows` list.
    all_shows: yup.boolean().required().default(true),
    show_ids: yup
      .array()
      .of(yup.string().required())
      .default([])
      .when("all_shows", {
        is: false,
        then: (schema) => schema.min(1, "Select at least one show"),
      }),
    active: yup.boolean().required().default(true),
  })
  .required();
